import {
  Container,
  Box,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
// import useStyles from "./styles";

import { useSharedBookReducer } from "../state";

const SignupContactInfo = ({ onComplete }) => {
  const [bookState, dispatch] = useSharedBookReducer();

  return (
    <>
      {/* Promo.details.title?? */}

      <Button
        variant="contained"
        color="success"
        size="large"
        onClick={bookState.saving ? null : onComplete}
        fullWidth
      >
        {bookState.saving ? "Please wait..." : "Finish Signup"}
      </Button>

      {/* 
							<h3 class="title is-4" v-if="promo.details">
								<span style="font-weight:normal;">\{{promo.details.title}}</span>
							</h3>

							<a id="signup" class="button is-success is-fullwidth" v-on:click="signup" :disabled="!!submitted">
								<span>Complete Signup</span>
							</a>

       */}
    </>
  );
};

export default SignupContactInfo;
